<template>
  <div class="p-4 text-center">Redirecting…</div>
</template>

<script>
import {
  PAYMENT_STATUS_OUTCOME_FAILURE,
  PAYMENT_STATUS_OUTCOME_INSPECTION,
  PAYMENT_STATUS_OUTCOME_PENDING,
  PAYMENT_STATUS_OUTCOME_QUERY_KEY,
  PAYMENT_STATUS_OUTCOME_REQUIREMENTS,
  PAYMENT_STATUS_OUTCOME_STORAGE_KEY,
  PAYMENT_STATUS_OUTCOME_SUCCESS,
  PAYMENT_STATUS_PATH,
} from '@/lib/payment/payment-status-constants';

const PATH_OUTCOME_MAP = {
  '/payment': PAYMENT_STATUS_OUTCOME_SUCCESS,
  '/paymentfailed': PAYMENT_STATUS_OUTCOME_FAILURE,
  '/inspection': PAYMENT_STATUS_OUTCOME_INSPECTION,
  '/pending': PAYMENT_STATUS_OUTCOME_REQUIREMENTS,
};

export default {
  name: 'PaymentOutcomeLegacyRedirect',
  mounted() {
    const outcome =
      PATH_OUTCOME_MAP[this.$route.path] || PAYMENT_STATUS_OUTCOME_PENDING;
    sessionStorage.setItem(PAYMENT_STATUS_OUTCOME_STORAGE_KEY, outcome);
    const query = {
      ...this.$route.query,
      [PAYMENT_STATUS_OUTCOME_QUERY_KEY]: outcome,
    };
    if (!query.journeyId) {
      try {
        const journeyId = JSON.parse(sessionStorage.getItem('journey_id'));
        if (journeyId) {
          query.journeyId = journeyId;
        }
      } catch {
        /* ignore */
      }
    }
    this.$router.replace({ path: PAYMENT_STATUS_PATH, query });
  },
};
</script>
